import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Icon from 'semantic-ui-react/dist/commonjs/elements/Icon';
//styles
import './user-flow-timeline.css';
import { TimelineInstapointsInfo } from './timeline-instapoints-info/TimelineInstapointsInfo';
import { getTimelineHeadingConfig } from '../../utils/instapoints-timeline/instapoints-timeline';
import { timelineBlinker } from '../../utils/library';
import {
  DEVICE_MOBILE,
  INDIVIDUAL,
  REGISTERED,
  INITIATED,
  ACKNOWLEDGED,
  SCREEN_NAME_DOCUMENT_UPLOAD,
  SCREEN_NAME_SEND_MONEY,
  DASHBOARD_URL,
  SCREEN_NAME_ACKNOWLEDGEMENT,
  APPROVED,
  SCREEN_NAME_PERSONAL_DETAILS,
  MY_INFO_RESGISTRATION_URL,
  SCREEN_NAME_BENE_ADDITIONAL_INFO,
  SCREEN_NAME_BENE_INFO_CORRECTION
} from '../../utils/constants';
import {
  changeScreen,
  destroyUserFlowAction
} from '../../redux/actions/user-flow/user-flow-action';
import { USER_FLOW_PREV } from '../../redux/action-contants';
import {
  TimeLineLabel,
  TimeLineContainer,
  TimelineSeparator,
  MobileTimeLineContainer,
  TimeLineLabelContainer,
  BackButton,
  StepContainer,
  ActiveStep,
  StepIPContainer,
  IP,
  ToolTipContainer,
  IPMobileContainer
} from './user-flow-timeline.style';
import get from 'lodash/get';
import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import TooltipModal from '../mobileTooltipModal/tooltipModal';
import withRouterV6 from '../common/withRouterV6';
import { BACK_ARROW_SVG_ICON, INFO_GREY_ICON, TIMELINE_BULLET_COMPLETED_ICON } from '@Images';

const inferBulletClassName = (status) => {
  switch (status) {
    case 'processing':
      return 'current-screen-timeline';
    case 'completed':
      return 'form-proccess-top-left-icon-inner';
    default:
      return '';
  }
};

const inferLabelClassName = (status) => {
  switch (status) {
    case 'processing':
      return 'processing';
    case 'completed':
      return 'completed';
    case 'pending':
      return 'disabled-text';
    default:
      return '';
  }
};

const showTimelineSection = (timeline, bullet, index) => {
  if (bullet.status === 'processing') return 'processing';
  else if (timeline[index + 1] && timeline[index + 1].status === 'processing') {
    if (index === 1) return 'processing next-of-start';
    else return 'prev-of-processing';
  } else if (timeline[index - 1] && timeline[index - 1].status === 'processing') {
    if (index === 1) return 'processing next-of-start';
    else return 'next-of-processing';
  } else if (index === 2 && timeline[index - 2] && timeline[index - 2].status === 'processing')
    return 'next-of-next-of-processing';
  else if (
    index === timeline.length - 3 &&
    timeline[index + 2] &&
    timeline[index + 2].status === 'processing'
  )
    return 'prev-of-prev-of-processing';
  else return '';
};

class UserFlowTimeline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timeline: props.timeline,
      screens: props.screens,
      currentScreen: props.currentScreen,
      // need to show timeline for SG on ACK screen
      timerVal:
        props.userStatusReducer.account_type === INDIVIDUAL &&
        props.userStatusReducer.country_code === 'SG' &&
        props.userStatusReducer.status === ACKNOWLEDGED
          ? true
          : null,
      timelineFlowIndex: -1,
      currentScreenFlowIndex: -1
    };
  }

  showBullets = (timeline) => {
    if (!timeline) return null;
    return timeline.map((bullet, index) => {
      let { label, status, timeline_meta, key } = bullet,
        timelineLength = timeline.length,
        headingConfig = getTimelineHeadingConfig(
          this.props.instaPointsLogicData,
          this.props.user_session,
          this.props.referred_by_referral_code
        );
      return (
        <div
          key={Math.random() * 10000}
          className={
            'bullet-wrapper ' +
            (timelineLength > 3
              ? showTimelineSection(timeline, bullet, index)
              : 'show-all-timeline-section')
          }
        >
          <p className={inferLabelClassName(status)}>{label}</p>
          <div className={`form-proccess-top-left-icon ${status}`}>
            {status === 'completed' ? (
              <img
                src={TIMELINE_BULLET_COMPLETED_ICON}
                className="timeline-section-completed"
                alt="completed timeline check icon"
              />
            ) : (
              <span className={inferBulletClassName(status)} />
            )}
          </div>
          {index < timelineLength - 1 && (
            <span className={`progress-line ${status}`}>
              {status === 'completed' && <span className="completed-anime" />}
            </span>
          )}
          {this.props.user_session &&
            this.props.user_session.account_type === INDIVIDUAL &&
            this.state.timerVal &&
            // instapoints logic
            ((timeline_meta && key !== 'personal') ||
              (this.props.user_session.isReferralCodeSubmittedOnPersonalDetails &&
                key === 'personal')) && (
              <TimelineInstapointsInfo
                timelineLength={timelineLength}
                timeline_meta={timeline_meta}
                index={index}
                headingConfig={headingConfig}
                configFor={key}
                timerVal={this.state.timerVal}
                device={this.props.device}
              />
            )}
        </div>
      );
    });
  };

  getIntervalTimeCB = (data) => {
    if (data.isExpired) {
      this.setState({ timerVal: null });
    } else {
      this.setState({ timerVal: `${data.hours}h ${data.minutes}m left` });
    }
  };

  componentDidMount = () => {
    const { user_session, remitterDetails, instaPointsLogicData, userStatusReducer, device } =
        this.props,
      { timeline } = this.state;
    if (
      user_session &&
      user_session.account_type === INDIVIDUAL &&
      user_session.country_code !== 'MY' &&
      remitterDetails &&
      instaPointsLogicData
    ) {
      if (
        userStatusReducer &&
        userStatusReducer.status &&
        userStatusReducer.status &&
        [REGISTERED, INITIATED, ACKNOWLEDGED].includes(userStatusReducer.status)
      ) {
        timelineBlinker({
          createdAt: remitterDetails.created_at,
          totalHrsLimit: instaPointsLogicData.acknowledgement_instapoint_hours_limit,
          callback: this.getIntervalTimeCB
        });
      }

      if (timeline && timeline.length && device === DEVICE_MOBILE) {
        let reqIndex = timeline.findIndex((x) => x.status === 'processing');
        this.setState({
          timelineFlowIndex: reqIndex,
          currentScreenFlowIndex: reqIndex
        });
      }
    }
  };

  async componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.timeline) !== JSON.stringify(this.props.timeline)) {
      await this.setState({
        timeline: this.props.timeline,
        screens: this.props.screens,
        currentScreen: this.props.currentScreen
      });
    }

    if (
      this.props.currentScreen !== prevProps.currentScreen &&
      this.props.device === DEVICE_MOBILE
    ) {
      let currentTimelineSequence = this.state.screens.find(
        (x) => x.name === this.props.currentScreen
      );
      if (currentTimelineSequence) {
        let reqIndex = this.state.timeline.findIndex(
          (x) => x.timeline_sequence === currentTimelineSequence.timeline_sequence
        );
        await this.setState({
          timelineFlowIndex: reqIndex,
          currentScreenFlowIndex: reqIndex
        });
      }
    }
  }

  moveTimeline = (clickedOn) => {
    let timelineFlowIndex = this.state.timelineFlowIndex;
    if (clickedOn === 'prev') timelineFlowIndex--;
    else timelineFlowIndex++;
    this.setState({ timelineFlowIndex });
  };

  renderSteps = (timeline) => {
    let { timelineFlowIndex, currentScreenFlowIndex, timerVal } = this.state;
    let { instaPointsLogicData, user_session, referred_by_referral_code, device } = this.props;
    let disablePrev = false,
      disableNext = false,
      timelineLength = timeline.length,
      headingConfig = getTimelineHeadingConfig(
        instaPointsLogicData,
        user_session,
        referred_by_referral_code
      );
    if (timelineFlowIndex === 0) disablePrev = true;
    else if (timelineFlowIndex === timelineLength - 1) disableNext = true;
    return (
      <Fragment>
        <div className="steps">
          <span>Step</span>
          {timeline && timelineLength && (
            <ul>
              {timeline.map((x, index) => (
                <li
                  key={Math.random() * 100000}
                  className={`step-no ${currentScreenFlowIndex === index ? 'current-flow' : null} ${
                    currentScreenFlowIndex > index ? 'completed-flow' : ''
                  }`}
                >
                  {index + 1}
                </li>
              ))}
            </ul>
          )}
        </div>
        <Icon
          disabled={disablePrev}
          className="timline-arrow"
          name="angle left"
          onClick={() => {
            return disablePrev ? null : this.moveTimeline('prev');
          }}
        />
        <Icon
          disabled={disableNext}
          className="timline-arrow"
          name="angle right"
          onClick={() => (disableNext ? null : this.moveTimeline('next'))}
        />
        {!disablePrev && !disableNext && this.state.timerVal && (
          <Fragment>
            <div className="left-instapoint-logic-info instapoint-logic-info">
              <TimelineInstapointsInfo
                timelineLength={timelineLength}
                timeline_meta={timeline[0].timeline_meta}
                index={0}
                position={'bottom left'}
                headingConfig={headingConfig}
                configFor={timeline[0].key}
                timerVal={timerVal}
                device={device}
              />
            </div>
            <div className="right-instapoint-logic-info instapoint-logic-info">
              <TimelineInstapointsInfo
                timelineLength={timelineLength}
                timeline_meta={timeline[timelineLength - 1].timeline_meta}
                index={timelineLength - 1}
                headingConfig={headingConfig}
                configFor={timeline[timelineLength - 1].key}
                timerVal={timerVal}
                position={'bottom right'}
                device={device}
              />
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  };

  timelineWrapperStyling = (timeline, timelineFlowIndex, is_new_user_flow, currentScreen) => {
    if (is_new_user_flow) {
      return {
        display: [SCREEN_NAME_BENE_ADDITIONAL_INFO, SCREEN_NAME_BENE_INFO_CORRECTION].includes(
          this.props.currentScreen
        )
          ? 'none'
          : 'flex',
        justifyContent: 'center',
        padding: '0 15%'
      };
    }
    if (this.props.device === DEVICE_MOBILE) {
      return {
        width: `${timeline.length * 200}px`,
        transform: `translateX(-${timelineFlowIndex * 200}px)`
      };
    } else return null;
  };
  renderOldTimeLine = () => {
    const { timeline, currentScreen, timelineFlowIndex } = this.state;
    return (
      <div className="timeline">
        <div className="form-proccess-top-main desktop-timeline">
          <div className="timeline-slider-wrapper">{this.renderSteps(timeline, currentScreen)}</div>
          <div className="timeline-list">
            <div
              className="timeline-wrapper"
              style={this.timelineWrapperStyling(timeline, timelineFlowIndex)}
            >
              {this.showBullets(timeline, timelineFlowIndex)}
            </div>
          </div>
        </div>
      </div>
    );
  };
  goBackNewTimeline = async () => {
    const { timeline, screens, currentScreen, dispatch, documentTimeLine } = this.props;
    if (
      currentScreen &&
      currentScreen === SCREEN_NAME_DOCUMENT_UPLOAD &&
      documentTimeLine &&
      Object.keys(documentTimeLine).length > 0 &&
      documentTimeLine.selectedDocIndex > 0
    ) {
      documentTimeLine.backFunction();
    } else {
      let timelineFlowIndex = this.state.timelineFlowIndex;
      timelineFlowIndex--;
      await this.setState({ timelineFlowIndex });
      dispatch(changeScreen(USER_FLOW_PREV, currentScreen, screens, timeline));
    }
  };
  getScreenName = (currentScreen) => {
    switch (currentScreen) {
      case 'send_money':
        return 'Recipient & amount';
      case 'payment_method':
        return 'Payment method';
      case 'acknowledgement':
        return 'Acknowledgement';
      case 'individual_documents_upload':
        return 'Verify';
      case 'personal_details':
        return 'Personal';
      default:
        break;
    }
  };

  getInstapoints = (hederConfig) => {
    const signUpHeading = get(hederConfig, 'signUpHeading', null);
    if (!signUpHeading) {
      return;
    }
    return signUpHeading.reduce((acc, pre) => {
      if (pre.title === 'Sign Up Bonus' || pre.title === 'Total') {
        return [...acc, pre.value];
      }
      return acc;
    }, []);
  };
  getScreenNameWeb = (label, hederConfig, onlyWidth) => {
    const [initialInstapoinst = null, totalInstapoinst = null] = this.getInstapoints(hederConfig);
    const { timerVal } = this.state;
    if (onlyWidth && timerVal && this.props.userStatusReducer.status !== APPROVED) {
      if (initialInstapoinst && totalInstapoinst) {
        return '79%';
      }
      return null;
    }
    switch (label) {
      case 'Sign Up':
        return timerVal && initialInstapoinst ? `Sign up with ${initialInstapoinst}   ` : 'Sign up';
      case 'Send':
        return 'Recipient & amount';
      case 'Recipient':
        return 'Payment method';
      case 'Documents':
        return 'Verify';
      case 'Acknowledgement':
        return timerVal &&
          totalInstapoinst &&
          this.props.instaPointsLogicData.welcome_instapoint > 0
          ? `   Acknowledge with ${totalInstapoinst}`
          : 'Acknowledge';
      default:
        return label;
    }
  };
  pushToUrlandDistroyFlow = (url) => {
    this.props.navigate(url);
    this.props.dispatch(destroyUserFlowAction());
  };
  renderNewTimeLine = () => {
    const { timeline, timelineFlowIndex } = this.state;
    const { currentScreen, instaPointsLogicData, user_session, referred_by_referral_code } =
      this.props;
    let review_index = timeline.findIndex((i) => i.label === 'Review');
    if (review_index !== -1) {
      timeline.splice(review_index, 1);
    }
    let headingConfig = getTimelineHeadingConfig(
      instaPointsLogicData,
      user_session,
      referred_by_referral_code
    );
    const [initialInstapoinst = null, totalInstapoinst = null] = this.getInstapoints(headingConfig);
    // eslint-disable-next-line max-len
    const instapointGenralmessage = `Congrats! you have received ${initialInstapoinst} bonus InstaPoints. Complete your profile in next ${instaPointsLogicData.acknowledgement_instapoint_hours_limit} hours and get ${totalInstapoinst} extra InstaPoints.`;
    const instapointMessageForAck = `Congrats! you have received ${totalInstapoinst} bonus InstaPoints. `;
    const instapointMessage =
      this.props.userStatusReducer.status === ACKNOWLEDGED
        ? instapointMessageForAck
        : instapointGenralmessage;

    // hack to show timeline on ACK
    const activeStep =
      currentScreen === SCREEN_NAME_ACKNOWLEDGEMENT
        ? timeline.length
        : timelineFlowIndex <= 0
        ? 1
        : timelineFlowIndex + 1;
    const isSbmReferral = get(
      this.props,
      'transactionDetails.additional_info.is_sbm_referral',
      false
    );
    return (
      <div className="timeline">
        <div className="form-proccess-top-main desktop-timeline">
          {![SCREEN_NAME_BENE_ADDITIONAL_INFO, SCREEN_NAME_BENE_INFO_CORRECTION].includes(
            currentScreen
          ) && (
            <div className="timeline-slider-wrapper">
              <MobileTimeLineContainer>
                {currentScreen !== SCREEN_NAME_ACKNOWLEDGEMENT && (
                  <BackButton
                    onClick={() => {
                      if (
                        this.props.featureState.toggleFeature &&
                        this.props.currentScreen === SCREEN_NAME_SEND_MONEY
                      ) {
                        this.pushToUrlandDistroyFlow(DASHBOARD_URL);
                        return;
                      }
                      if (timelineFlowIndex <= 0 || timelineFlowIndex >= timeline.length - 1) {
                        return;
                      }
                      if (
                        this.props.featureState.toggleFeature &&
                        this.props.currentScreen === SCREEN_NAME_PERSONAL_DETAILS
                      ) {
                        this.pushToUrlandDistroyFlow(MY_INFO_RESGISTRATION_URL);
                        return;
                      }
                      this.goBackNewTimeline();
                    }}
                  >
                    <img alt="back" src={BACK_ARROW_SVG_ICON} />
                  </BackButton>
                )}
                <StepIPContainer>
                  <StepContainer $isSbmReferral={isSbmReferral}>
                    Step
                    <ActiveStep $isSbmReferral={isSbmReferral}>{activeStep}</ActiveStep>/
                    {timeline.length}
                    <ActiveStep $isSbmReferral={isSbmReferral}>
                      {this.getScreenName(currentScreen)}
                    </ActiveStep>
                  </StepContainer>
                  {this.state.timerVal && (
                    <IPMobileContainer>
                      <IP>
                        {`instapoints ${initialInstapoinst.replace('IPs', '').trim()}`}
                        <span>{`/${totalInstapoinst}`}</span>
                      </IP>
                      {this.props.instaPointsLogicData.welcome_instapoint > 0 && (
                        <TooltipModal
                          triggerContent={
                            <img
                              src={INFO_GREY_ICON}
                              alt="address tooltip"
                              width="10px"
                              height="10px"
                            />
                          }
                          title={'InstaPoints'}
                          content={instapointMessage}
                        />
                      )}
                    </IPMobileContainer>
                  )}
                </StepIPContainer>
              </MobileTimeLineContainer>
            </div>
          )}
          <div className="timeline-list new-timeline">
            <div
              className="timeline-wrapper"
              style={this.timelineWrapperStyling(timeline, timelineFlowIndex, true)}
            >
              <TimeLineContainer
                id="time-line-container"
                width={this.getScreenNameWeb(null, headingConfig, true)}
              >
                {timeline.map((i, j) => {
                  return (
                    <>
                      <TimeLineLabelContainer key={Math.random() * 100000}>
                        <TimeLineLabel
                          id={i.status}
                          $status={i.status}
                          $isSbmReferral={isSbmReferral}
                        >
                          {this.getScreenNameWeb(i.label, headingConfig)}
                        </TimeLineLabel>
                      </TimeLineLabelContainer>
                      {j < timeline.length - 1 && <TimelineSeparator></TimelineSeparator>}
                    </>
                  );
                })}
                {this.state.timerVal && this.props.instaPointsLogicData.welcome_instapoint > 0 && (
                  <ToolTipContainer>
                    <Popup
                      position="bottom right"
                      content={
                        <div
                          style={{
                            fontFamily: 'hellix-regular',
                            fontSize: '9px',
                            fontWeight: 'normal',
                            fontStretch: 'normal',
                            fontStyle: 'normal',
                            lineHeight: '1.56',
                            letterSpacing: 'normal',
                            color: '#202859'
                          }}
                        >
                          {instapointMessage}
                        </div>
                      }
                      trigger={
                        <img
                          src={INFO_GREY_ICON}
                          alt="address tooltip"
                          width="10px"
                          height="10px"
                        />
                      }
                    />
                  </ToolTipContainer>
                )}
              </TimeLineContainer>
            </div>
          </div>
        </div>
      </div>
    );
  };
  render() {
    const { toggleFeature } = this.props.featureState;
    return <>{!toggleFeature ? this.renderOldTimeLine() : this.renderNewTimeLine()}</>;
  }
}

UserFlowTimeline.propTypes = {
  timeline: PropTypes.array,
  screens: PropTypes.array,
  currentScreen: PropTypes.string,
  user_session: PropTypes.object,
  instaPointsLogicData: PropTypes.object,
  remitterDetails: PropTypes.object,
  device: PropTypes.string,
  userStatusReducer: PropTypes.object,
  referred_by_referral_code: PropTypes.any,
  documentTimeLine: PropTypes.any,
  featureState: PropTypes.shape({
    toggleFeature: PropTypes.bool
  }),
  dispatch: PropTypes.any,
  navigate: PropTypes.func,
  transactionReducer: PropTypes.object
};

function mapStateToProps(state) {
  const {
    rootReducer: {
      userFlowReducer: { timeline, screens, currentScreen, documentTimeLine },
      userDataReducer: {
        instaPointsLogicData,
        userStateInfo: { remitterDetails }
      },
      uiTriggerState: { device },
      userStatusReducer,
      transactionReducer: { transactionDetails }
    }
  } = state;

  return {
    timeline,
    screens,
    currentScreen,
    instaPointsLogicData,
    remitterDetails,
    device,
    userStatusReducer,
    documentTimeLine,
    transactionDetails
  };
}

export default withRouterV6(connect(mapStateToProps)(UserFlowTimeline));
